export enum MailStatus {
  ACKNOWLEDGED = "ACKNOWLEDGED",
  PENDING = "PENDING",
  ERROR = "ERROR",
  BLOCKED = "BLOCKED",
  SENT = "SENT",
  OPENED = "OPENED",
  BOUNCED = "BOUNCED",
  SPAM = "SPAM",
  UNAUTHORIZED = "UNAUTHORIZED",
  AUTHORIZED = "AUTHORIZED",
  LOGGED = "LOGGED",
  INACTIVE_TAKIMA_USER = "INACTIVE_TAKIMA_USER"
}

type MailStatusPropertiesType = {
  [key in MailStatus]: {
    value: string;
    color: string;
    description: string;
    retryEligible: boolean;
  };
};

export const MailStatusProperties: MailStatusPropertiesType = {
  [MailStatus.ACKNOWLEDGED]: {
    value: "Acknowledged",
    color: "blue",
    description: "Mailjet is treating your request.",
    retryEligible: true
  },
  [MailStatus.PENDING]: {
    value: "Pending",
    color: "orange",
    description: "Pending",
    retryEligible: false
  },
  [MailStatus.ERROR]: {
    value: "Error",
    color: "red",
    description: "Something went wrong while sending the e-mail, check API's logs.",
    retryEligible: true
  },
  [MailStatus.BLOCKED]: {
    value: "Blocked",
    color: "red",
    description: "The e-mail has been blocked by the recipient.",
    retryEligible: true
  },
  [MailStatus.SENT]: {
    value: "Sent",
    color: "green",
    description: "The e-mail has been sent successfully.",
    retryEligible: false
  },
  [MailStatus.OPENED]: {
    value: "Opened",
    color: "green",
    description: "The e-mail has been opened by the recipient.",
    retryEligible: false
  },
  [MailStatus.BOUNCED]: {
    value: "Bounced",
    color: "red",
    description: "The e-mail could not be delivered to the recipient.",
    retryEligible: false
  },
  [MailStatus.SPAM]: {
    value: "Spam",
    color: "purple",
    description: "The e-mail has been marked as spam.",
    retryEligible: false
  },
  [MailStatus.UNAUTHORIZED]: {
    value: "Unauthorized",
    color: "gray",
    description:
      "The e-mail address is unauthorized to send e-mails. Consider giving the sender the correct rights in Mailjet.",
    retryEligible: true
  },
  [MailStatus.AUTHORIZED]: {
    value: "Authorized",
    color: "teal",
    description: "The e-mail address is authorized to send e-mails.",
    retryEligible: false
  },
  [MailStatus.LOGGED]: {
    value: "Logged",
    color: "gray",
    description: "This e-mail has not been send to the recipient.",
    retryEligible: false
  },
  [MailStatus.INACTIVE_TAKIMA_USER]: {
    value: "Inactive Takima User",
    color: "red",
    description: "This e-mail has not been sent to the recipient (inactive recipient address)",
    retryEligible: true
  }
};
